<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12">
        <v-toolbar-title>Dashboard</v-toolbar-title>
      </v-col>
    </v-row>
    <SummaryReport></SummaryReport>
    <DailyRevenue></DailyRevenue>
    <DailyActivation></DailyActivation>
    <onu-charts></onu-charts>
    <!-- <DailySignUp></DailySignUp> -->
  </v-container>
</template>

<script>
import SummaryReport from "./components/dashboard_components/SummaryReport.vue";
import DailyRevenue from "./components/dashboard_components/DailyRevenue.vue";
import DailyActivation from "./components/dashboard_components/DailyActivation.vue";
import OnuCharts from './components/dashboard_components/OnuCharts.vue'
// import DailySignUp from "../page_components/dashboard_components/DailySignUp.vue";

export default {
  name: "Dashboard",
  components: {
    SummaryReport,
    DailyRevenue,
    DailyActivation,
    OnuCharts
    // DailySignUp
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
